export const underlyingLayout = {
  dragmode: "zoom",
  autosize: true,
  margin: { l: 40, r: 90, t: 25, b: 40 },
  showlegend: true,
  legend: { orientation: "h", y: 1.02, x: 0, xanchor: "left", yanchor: "bottom" },
  hovermode: "closest",
  hoverdistance: 25,
  xaxis: {
    autorange: true,
    domain: [0, 1],
    rangeslider: { visible: false },
    type: "date",
    showspikes: true,
    spikesnap: "cursor",
    spikecolor: "#999",
    spikethickness: 1,
    spikemode: "toaxis+across+marker",
    spikedash: "solid",
    showgrid: true,
  },
  yaxis: {
    autorange: true,
    domain: [0.25, 1],
    type: "linear",
    showspikes: true,
    spikemode: "toaxis+across+marker",
    spikesnap: "cursor",
    spikedash: "solid",
    spikecolor: "#999",
    spikethickness: 1,
    showgrid: true,
  },
  yaxis2: {
    domain: [0, 0.2],
    type: "linear",
    showticklabels: false,
    showgrid: false,
    fixedrange: true,
  },
};

export const optPricingLayout = {
  dragmode: "zoom",
  autosize: true,
  margin: { l: 40, r: 90, t: 0, b: 40 },
  showlegend: true,
  legend: {
    x: 0, // left side
    y: 1, // bottom
    xanchor: "left",
    yanchor: "top",
  },

  hovermode: "closest", // crosshairs
  hoverdistance: 25,
  xaxis: {
    autorange: true,
    domain: [0, 1],
    rangeslider: { visible: false },
    type: "date",
    // crosshairs
    showspikes: true,
    spikesnap: "cursor",
    spikecolor: "#999",
    spikethickness: 1,
    spikemode: "toaxis+across+marker",
    spikedash: "solid",
    showgrid: true,
  },
  yaxis: {
    autorange: true,
    domain: [0, 1],
    type: "linear",
    // crosshairs
    showspikes: true,
    spikemode: "toaxis+across+marker",
    spikesnap: "cursor",
    spikedash: "solid",
    spikecolor: "#999",
    spikethickness: 1,
    showgrid: true,
  },
};
export const optIvLayout = {
  dragmode: "zoom",
  autosize: true,
  margin: { l: 40, r: 90, t: 0, b: 40 },
  showlegend: true,
  legend: {
    x: 0, // left side
    y: 1, // bottom
    xanchor: "left",
    yanchor: "top",
  },

  hovermode: "closest", // crosshairs
  hoverdistance: 25,
  xaxis: {
    autorange: true,
    domain: [0, 1],
    rangeslider: { visible: false },
    type: "date",
    // crosshairs
    showspikes: true,
    spikesnap: "cursor",
    spikecolor: "#999",
    spikethickness: 1,
    spikemode: "toaxis+across+marker",
    spikedash: "solid",
    showgrid: true,
  },
  yaxis: {
    autorange: true,
    domain: [0, 1],
    type: "linear",
    // crosshairs
    showspikes: true,
    spikemode: "toaxis+across+marker",
    spikesnap: "cursor",
    spikedash: "solid",
    spikecolor: "#999",
    spikethickness: 1,
    showgrid: true,
  },
};
